import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { PipelineEnvironment } from '@telespot/domain';

export interface Pipeline {
  id: string;
  names: Record<string, string>;
  environment: PipelineEnvironment;
}

export const pipelineAdapter = createEntityAdapter<Pipeline>();